module.exports = __webpack_public_path__ + "static/img/copy_success.e80ec29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/mitu/order/pop/copy_success.png
// module id = fo2u
// module chunks = 1